"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApiState = void 0;
const react_1 = require("react");
const ApiState_1 = require("./ApiState");
const Alerts_1 = require("../Alerts");
const useApiState = (props) => {
    const [apiState, setApiState] = (0, react_1.useState)((0, ApiState_1.createApiState)());
    const { addErrorAlert } = (0, Alerts_1.useAlert)();
    const setState = (state) => {
        props?.setter ? props.setter(state) : setApiState(state);
    };
    const getState = () => {
        return props?.getter ? props.getter() : apiState;
    };
    const dispatchInvalidate = () => {
        setState((0, ApiState_1.createApiState)());
    };
    const dispatchLoadingAction = () => {
        setState({
            ...getState(),
            data: null,
            loading: true,
            success: false,
            error: null
        });
    };
    const fetchApiState = (fetchPromise, callback) => {
        (async () => {
            dispatchLoadingAction();
            try {
                const data = await fetchPromise();
                dispatchSuccessAction(data);
                if (callback)
                    callback(data);
            }
            catch (err) {
                console.log("error action", err);
                dispatchErrorAction(err);
            }
        })();
    };
    const dispatchSuccessAction = (data) => {
        setState({
            ...getState(),
            success: true,
            data: data,
            loading: false,
            error: null
        });
    };
    const dispatchErrorAction = (error) => {
        if (error && typeof error === 'object' && error?.requestType === 'post') {
            //addErrorAlert({id: "post-error", message:'Tuto akci se nepodařilo zpracovat. Zkuste stránku obnovit.'})
        }
        // if(error && error.errorMessage ){
        //     addErrorAlert({id: "connection-error", message:'Bohužel se objevila chyba při připojování na server.'})
        // }
        setState({
            ...getState(),
            error: { url: "nope", body: "hello", status: 404 },
            loading: false,
            success: false,
            data: null,
        });
    };
    return {
        apiState: getState(),
        fetchApiState,
        invalidateApiState: dispatchInvalidate
    };
};
exports.useApiState = useApiState;
